if (!customElements.get('product-countdown')) {
  const defaultDuration = 180;
  const mobileBreakpoint = 1000;
  const stickyClass = 'product-countdown--mobile-sticky';
  const stickyActiveClass = 'product-countdown--mobile-sticky--active';
  const stickyOffsetVar = '--product-countdown-mobile-button-offset';

  customElements.define('product-countdown', class ProductCountdown extends HTMLElement {
    constructor() {
      super();
      this._intervalId = null;
      this._remainingSeconds = 0;

      this._isMobileStickyEnabled = false;
      this._controlsGroup = null;
      this._stickyButton = null;
      this._mediaQuery = null;
      this._updateMobileStickyState = this._updateMobileStickyState.bind(this);
      this._onViewportChange = this._onViewportChange.bind(this);
      this._mutationObserver = null;
    }

    connectedCallback() {
      this._startCountdown();
      this._setupMobileSticky();
    }

    disconnectedCallback() {
      this._clearInterval();
      this._teardownMobileSticky();
    }

    _startCountdown() {
      this._clearInterval();
      this.classList.remove('product-countdown--hidden');

      const duration = parseInt(this.dataset.productCountdownDuration, 10) || defaultDuration;
      this._remainingSeconds = Math.max(duration, 0);

      if (this._remainingSeconds <= 0) {
        this._hide();
        return;
      }

      this._update();
      this._intervalId = setInterval(() => this._tick(), 1000);
    }

    _tick() {
      if (this._remainingSeconds <= 0) {
        this._hide();
        return;
      }

      this._remainingSeconds -= 1;

      if (this._remainingSeconds <= 0) {
        this._hide();
        return;
      }

      this._update();
    }

    _update() {
      const minutes = String(Math.floor(this._remainingSeconds / 60)).padStart(2, '0');
      const seconds = String(this._remainingSeconds % 60).padStart(2, '0');
      const minutesElement = this.querySelector('[data-product-countdown-minutes]');
      const secondsElement = this.querySelector('[data-product-countdown-seconds]');

      if (minutesElement) {
        minutesElement.textContent = minutes;
      }

      if (secondsElement) {
        secondsElement.textContent = seconds;
      }
    }

    _hide() {
      this._clearInterval();
      this.classList.add('product-countdown--hidden');
      this._deactivateMobileSticky();
    }

    _clearInterval() {
      if (this._intervalId) {
        clearInterval(this._intervalId);
        this._intervalId = null;
      }
    }

    _setupMobileSticky() {
      this._isMobileStickyEnabled =
        this.dataset.productCountdownMobileSticky === 'true' ||
        this.classList.contains(stickyClass);

      if (!this._isMobileStickyEnabled) return;

      this._controlsGroup = document.querySelector('[data-controls-group-submit]');
      this._stickyButton = document.querySelector('.product-form__button--fixed');
      this._mediaQuery = window.matchMedia(`(max-width: ${mobileBreakpoint}px)`);

      if (!this._mediaQuery) {
        return;
      }

      window.addEventListener('scroll', this._updateMobileStickyState, { passive: true });
      window.addEventListener('resize', this._updateMobileStickyState);
      if (typeof this._mediaQuery.addEventListener === 'function') {
        this._mediaQuery.addEventListener('change', this._onViewportChange);
      } else {
        this._mediaQuery.addListener(this._onViewportChange);
      }

      if (this._controlsGroup) {
        this._mutationObserver = new MutationObserver(this._updateMobileStickyState);
        this._mutationObserver.observe(this._controlsGroup, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      this._updateMobileStickyState();
    }

    _onViewportChange() {
      this._updateMobileStickyState();
    }

    _updateMobileStickyState() {
      if (!this._mediaQuery.matches) {
        this._deactivateMobileSticky();
        return;
      }

      if (this.classList.contains('product-countdown--hidden')) {
        this._deactivateMobileSticky();
        return;
      }

      if (!this._controlsGroup) {
        this._controlsGroup = document.querySelector('[data-controls-group-submit]');

        if (this._controlsGroup && !this._mutationObserver) {
          this._mutationObserver = new MutationObserver(this._updateMobileStickyState);
          this._mutationObserver.observe(this._controlsGroup, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
      }

      if (!this._stickyButton) {
        this._stickyButton = document.querySelector('.product-form__button--fixed');
      }

      if (!this._controlsGroup || !this._stickyButton) {
        this._deactivateMobileSticky();
        return;
      }

      const isFixed = this._controlsGroup.classList.contains('fix-controls-group--submit');
      const buttonRect = this._stickyButton.getBoundingClientRect();
      const buttonHeight = buttonRect && buttonRect.height > 0 ? buttonRect.height : 0;

      if (!isFixed || buttonHeight <= 0) {
        this._deactivateMobileSticky();
        return;
      }

      this.style.setProperty(stickyOffsetVar, `${Math.round(buttonHeight)}px`);
      this.classList.add(stickyActiveClass);
    }

    _deactivateMobileSticky() {
      this.classList.remove(stickyActiveClass);
      this.style.removeProperty(stickyOffsetVar);
    }

    _teardownMobileSticky() {
      if (this._mutationObserver) {
        this._mutationObserver.disconnect();
        this._mutationObserver = null;
      }

      if (this._mediaQuery) {
        if (typeof this._mediaQuery.removeEventListener === 'function') {
          this._mediaQuery.removeEventListener('change', this._onViewportChange);
        } else {
          this._mediaQuery.removeListener(this._onViewportChange);
        }
      }

      window.removeEventListener('scroll', this._updateMobileStickyState);
      window.removeEventListener('resize', this._updateMobileStickyState);

      this._deactivateMobileSticky();
    }
  });
}
